import { render } from "./ExtendedHealthCheck.vue?vue&type=template&id=5b26d446&scoped=true"
import script from "./ExtendedHealthCheck.vue?vue&type=script&lang=js"
export * from "./ExtendedHealthCheck.vue?vue&type=script&lang=js"

import "./ExtendedHealthCheck.vue?vue&type=style&index=0&id=5b26d446&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b26d446"]])

export default __exports__